module.exports = __webpack_public_path__ + "static/media/btn_bookmark_on.17b3ab1e.svg";